import React, { useState } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { IconMenu2, IconPlus } from '@tabler/icons-react'
import { FieldArray } from 'formik'
import { isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'

export const ModalFields = ({
  items,
  name,
  RowComponent,
  handleAddItem,
  addItemLabel,
  errors,
  removeFromObject,
  disableDraggable = false,
  updateStatusInObject,
  updateNameInObject,
  updateWeightInObject,
}) => {
  const [lastItemAdded, setLastItemAdded] = useState(-1)
  const shouldFocus = (index) => {
    return index === lastItemAdded
  }
  const sortedItems = items?.sort((a, b) => a.order_id - b.order_id)

  return (
    <FieldArray name={name}>
      {({ remove, push }) => (
        <>
          <Droppable
            droppableId="1"
            renderClone={(provided, snapshot, rubric) => (
              <div
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
              >
                <IconMenu2 size={16} /> {items[rubric.source.index].name}
              </div>
            )}
          >
            {(provided) => (
              <div
                id="tasklist"
                className="flex-column small-gap mb"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {!isEmpty(sortedItems) &&
                  sortedItems.map((item, index) => (
                    <RowComponent
                      key={item.id}
                      items={items}
                      newItem={item}
                      index={index}
                      errors={errors}
                      remove={remove}
                      shouldFocus={shouldFocus(index)}
                      disableDraggable={disableDraggable}
                      removeObject={removeFromObject}
                      updateStatusInObject={updateStatusInObject}
                      updateNameInObject={updateNameInObject}
                      updateWeight={updateWeightInObject}
                    />
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <Button
            onClick={() => {
              handleAddItem(push, items)
              setLastItemAdded(items.length)
            }}
            data-testid="basic-modal-add-item-link"
          >
            <IconPlus /> {addItemLabel}
          </Button>
        </>
      )}
    </FieldArray>
  )
}
